<template>
    <div>
        <section>
            <b-field grouped position="is-right">
                <p class="control">
                    <b-button type="is-primary"
                              icon-pack="far"
                              :outlined="editable"
                              tag="a"
                              :icon-right="editable ? 'user-lock' : 'user-edit'"
                              :title="editable ? 'Bearbeitung sperren' : 'Bearbeitung aktivieren'"
                              @click="editable = !editable">

                    </b-button>
                </p>
                <p class="control">
                    <b-button type="is-info" icon-pack="far" icon-right="sync-alt"
                              @click="$root.getUsers($route.params.id)" :loading="$root.env.loading.users" :disabled="$root.env.loading.users"></b-button>
                </p>
                <p class="control">
                    <b-dropdown position="is-bottom-left" aria-role="menu" trap-focus  mobile-modal>
                        <b-button slot="trigger" :type="(filters.length > 0 || search.length >= 3) ? 'is-success' : 'is-light'" icon-pack="far"
                                  icon-right="filter"></b-button>

                        <b-dropdown-item
                                aria-role="menu-item"
                                :focusable="false"
                                style="width: 260px;"
                                custom>
                            <div class="buttons" style="justify-content: flex-end;">
                                <b-button icon-pack="far" icon-left="upload" :type="temp.filterLoad?'is-primary':'is-light'" size="is-small"
                                          title="Filter laden" @click="temp.filterLoad = !temp.filterLoad" :disabled="hideFilterMenu && !temp.filterLoad">

                                </b-button>
                                <b-button icon-pack="far" icon-left="download" type="is-light" size="is-small"
                                          title="Filter speichern" @click="saveFilter()" :disabled="hideFilterMenu">

                                </b-button>
                                <b-button icon-pack="far" icon-left="bullseye-arrow" :type="temp.saveTargetgroup?'is-primary':'is-light'" size="is-small"
                                          title="Zielgruppe erstellen" @click="temp.saveTargetgroup = !temp.saveTargetgroup" :disabled="hideFilterMenu && !temp.saveTargetgroup">

                                </b-button>
                                <b-button icon-pack="far" icon-left="file-export" type="is-light" size="is-small"
                                          title="Gefilterte Abonnenten exportieren" @click="exportFiltered()" :disabled="hideFilterMenu">

                                </b-button>
                                <b-button icon-pack="fas" icon-left="plus" type="is-success" size="is-small"
                                          @click="isCardModalActive = true" title="Filter hinzufügen" :disabled="hideFilterMenu">

                                </b-button>
                                <b-button icon-pack="fas" icon-left="backspace" type="is-danger" @click="clearFilter" size="is-small"
                                          title="Alle Filter löschen" :disabled="hideFilterMenu">

                                </b-button>
                            </div>

                        </b-dropdown-item>
                        <b-dropdown-item
                                aria-role="menu-item"
                                :focusable="false"
                                v-if="temp.filterLoad" class="field-grid"
                                custom>
                            <b-field label="Filter wählen">
                                <b-select placeholder="Bitte wählen" v-model="temp.filterToLoad">
                                    <option
                                            v-for="option in $root.event.filters"
                                            :value="option"
                                            :key="option.id">
                                        {{ option.label }}
                                    </option>
                                </b-select>
                            </b-field>
                        </b-dropdown-item>
                        <b-dropdown-item
                                aria-role="menu-item"
                                :focusable="false"
                                v-if="temp.filterLoad && temp.filterToLoad"

                                custom>
                            <b-button @click="loadFilter()" type="is-primary">Filter laden</b-button>
                        </b-dropdown-item>
                        <b-dropdown-item
                                aria-role="menu-item"
                                :focusable="false"
                                v-if="temp.saveTargetgroup" class="field-grid"
                                custom>
                            <b-field label="Zielgruppe wählen">
                                <b-select placeholder="Bitte wählen" v-model="temp.targetgroupToSave">
                                    <option
                                            :value="{type:'new',label:'neue Zielgruppe'}"
                                            :key="'newTargetgroup'">
                                        neue Zielgruppe erstellen
                                    </option>
                                    <option
                                            v-for="option in $root.event.targetgroups || []"
                                            :value="option"
                                            :key="option.id">
                                        {{ option.label }}
                                    </option>
                                </b-select>
                            </b-field>
                        </b-dropdown-item>
                        <b-dropdown-item
                                aria-role="menu-item"
                                :focusable="false"
                                v-if="temp.saveTargetgroup && temp.targetgroupToSave"

                                custom>
                            <b-button @click="saveTargetgroup()" type="is-primary">
                                {{temp.targetgroupToSave.type === 'new'?'Zielgruppe erstellen':'Zielgruppe aktualisieren'}}
                            </b-button>
                        </b-dropdown-item>
                        <b-dropdown-item
                                aria-role="menu-item"
                                :focusable="false"
                                v-if="!hideFilterMenu"
                                custom>
                            <b-field>
                                <b-radio-button v-model="filterMode" size="is-small"
                                                native-value="and">
                                    Und
                                </b-radio-button>

                                <b-radio-button v-model="filterMode" size="is-small"
                                                native-value="andOr">
                                    Und/Oder
                                </b-radio-button>

                                <b-radio-button v-model="filterMode" size="is-small"
                                                native-value="or">
                                    Oder
                                </b-radio-button>
                            </b-field>
                        </b-dropdown-item>
                        <b-dropdown-item separator
                                         v-if="!hideFilterMenu"></b-dropdown-item>
                        <b-dropdown-item
                                aria-role="menu-item"
                                :focusable="false"
                                v-if="!hideFilterMenu"
                                custom>
                            <b-field>
                                <b-input placeholder="Suche..." type="search" icon="search" v-model="search">
                                </b-input>
                            </b-field>
                        </b-dropdown-item>
                    </b-dropdown>
                </p>
                <p class="control">
                    <b-dropdown position="is-bottom-left"
                                v-model="$root.event.fields.table"
                                multiple
                                aria-role="list"
                                mobile-modal>
                        <b-button slot="trigger" type="is-light" icon-pack="far"
                                  icon-right="columns"></b-button>
                        <b-dropdown-item v-for="field in filteredAccountFields.filter(f => f.id != 1)" :value="field.id" aria-role="listitem">
                            <span>{{field.name}}</span>
                        </b-dropdown-item>
                    </b-dropdown>
                </p>
            </b-field>
            <b-field v-if="filters.length > 0 || search.length >= 3" class="filterTags">
                <b-tag type="is-light"
                       closable
                       v-if="search.length >= 3"
                       aria-close-label="Filter löschen"
                       @close="search = ''">
                    <b-icon size="is-small" pack="far" style="margin-right: 0;" icon="search">
                    </b-icon>
                    {{ search }}
                </b-tag>
                <b-tag type="is-light"
                       closable
                       v-for="(f,index) in filtersRendered"
                       aria-close-label="Filter löschen"
                       @close="filters.splice(index, 1)"
                       :title="f.fullLabel">
                    <b-icon size="is-small" pack="far" style="margin-right: 0;" v-for="icon in f.icons"
                            :icon="icon">
                    </b-icon>
                    {{ f.entity ? f.entity.label : '' }}
                </b-tag>
            </b-field>
        </section>
        <section style="margin: 1em;" v-if="$root.env.loading.users">
                <b-progress :value="progress" show-value type="is-primary">
                    {{$root.users.length}} / {{$root.event.counter.recipients}}
                </b-progress>
        </section>

        <b-table :data="filtered"
                 @details-open="(row, index) => prepUser(row)"
                 ref="table"
                 style="margin-top: 0.5em;"
                 paginated per-page="25"
                 detailed detail-key="id"
                 aria-next-label="Next page"
                 aria-previous-label="Previous page"
                 aria-page-label="Page"
                 aria-current-label="Current page"
                 icon-pack="fal"
                 :checked-rows.sync="checkedRows"
                 checkable
                 checkbox-position="left"
                 :key="updateTable">
            <template slot-scope="props">
                <b-table-column field="id" label="ID" width="40" numeric sortable>
                    {{ props.row.id }}
                </b-table-column>

                <b-table-column v-for="col in columns" :field="'field_'+col.id" :label="col.name" sortable>
                    <a @click="toggle(props.row)" v-html="$options.filters.emphSearch(props.row['field_'+col.id], search)"></a>
                </b-table-column>

                <b-table-column field="field_1" label="E-Mail" sortable>
                    <a @click="toggle(props.row)" v-html="$options.filters.emphSearch(props.row.field_1, search)"></a>
                </b-table-column>
            </template>

            <template slot="detail" slot-scope="props">
                <article class="media">
                    <figure class="media-left">
                        <p style="margin-bottom: 10px;">
                            <b-button size="is-medium" type="is-success" icon-left="save" icon-pack="fad"
                                      title="Nutzer speichern" @click="$root.saveUser(props.row.id,props.row.data)">
                            </b-button>
                        </p>
                        <p>
                            <b-button size="is-medium" type="is-info" icon-left="envelope" icon-pack="fad"
                                      title="Zusammenfassung versenden"
                                      @click="$root.saveUser(props.row.id,props.row.data,true, reset)">
                            </b-button>
                        </p>
                    </figure>
                    <div class="media-content">
                        <div class="content">
                            <b-tabs>
                                <b-tab-item label="Gastinformationen">
                                    <div class="field">
                                        <header>Rückmeldung</header>
                                        <b-field label="Zusage" horizontal>
                                            <b-checkbox v-model="props.row.data._attending" true-value="yes" false-value="no"
                                                        :disabled="!editable" v-if="props.row.data._attending === 'yes' || props.row.data._attending === 'no'"></b-checkbox>
                                            <p class="control" v-if="typeof props.row.data._attending === 'undefined'">
                                                noch keine Rückmeldung
                                            </p>
                                            <p class="control" v-if="typeof props.row.data._attending === 'undefined' && editable">
                                                <span class="buttons">
                                                    <b-button size="is-small" type="is-success" @click="props.row.data._attending = 'yes'">Zusagen</b-button>
                                                    <b-button size="is-small" type="is-danger" @click="props.row.data._attending = 'no'">Absagen</b-button>
                                                </span>
                                            </p>
                                        </b-field>
                                    </div>
                                    <div class="field">
                                        <header>Abonnentenfelder</header>
                                        <b-field v-for="input in $root.event.fields.shown"
                                                 :label="input.name+' ('+input.id+')'" horizontal>
                                            <b-input :value="props.row['field_'+input.id]" :disabled="!editable"
                                                     @input="value => {if(!props.row.data.alteredFields)props.row.data.alteredFields={};props.row.data.alteredFields[input.id] = value}"></b-input>
                                        </b-field>
                                        <b-field v-for="input in $root.event.fields.editable"
                                                 :label="input.name+' ('+input.id+')'" horizontal>
                                            <b-input :value="props.row['field_'+input.id]" :disabled="!editable"
                                                     @input="value => {if(!props.row.data.alteredFields)props.row.data.alteredFields={};props.row.data.alteredFields[input.id] = value}"></b-input>
                                        </b-field>
                                        <header>Zusätzliche Informationen:</header>
                                        <b-field v-for="input in $root.event.guests.guestFields"
                                                 :label="input.label" horizontal>
                                            <b-input
                                                    v-if="input.type == 'email'"
                                                    v-model="props.row.data.additionalInfo['info_'+input.name]"
                                                    type="email" :disabled="!editable"
                                                    icon="envelope"></b-input>
                                            <b-select
                                                    v-else-if="input.type == 'enum'"
                                                    v-model="props.row.data.additionalInfo['info_'+input.name]"
                                                    :disabled="!editable"
                                                    placeholder="Bitte auswählen">
                                                <option
                                                        v-for="option in input.options.split(',')"
                                                        :value="option">
                                                    {{ option }}
                                                </option>
                                            </b-select>
                                            <Datepicker
                                                    v-else-if="input.type == 'date'"
                                                    v-model="props.row.data.additionalInfo['info_'+input.name]"
                                                    :disabled="!editable"
                                                    icon="calendar-day"></Datepicker>
                                            <Timepicker
                                                    v-else-if="input.type == 'time'"
                                                    v-model="props.row.data.additionalInfo['info_'+input.name]"
                                                    :disabled="!editable"
                                                    icon="clock"></Timepicker>
                                            <b-numberinput
                                                    v-else-if="input.type == 'int'"
                                                    min="0"
                                                    icon-pack="fal"
                                                    v-model="props.row.data.additionalInfo['info_'+input.name]"
                                                    :disabled="!editable"></b-numberinput>
                                            <b-input
                                                    v-else-if="input.type == 'multiline'"
                                                    v-model="props.row.data.additionalInfo['info_'+input.name]"
                                                    :disabled="!editable"
                                                    type="textarea"></b-input>
                                            <b-input
                                                    v-else
                                                    v-model="props.row.data.additionalInfo['info_'+input.name]"
                                                    :disabled="!editable"></b-input>
                                        </b-field>
                                    </div>
                                </b-tab-item>
                                <b-tab-item :label="'Begleitung (max. '+$root.event.guests.companies+')'" v-if="$root.event.guests.companies > 0">
                                    <button class="button is-primary is-small"
                                            @click="addCompany(props.row.data)">
                                        <b-icon icon="user-plus" pack="fas"></b-icon>
                                    </button>
                                    <div class="guestBlocks">
                                        <div v-for="(compi, index) in props.row.data.companies">
                                            <div class="buttons">
                                                <button style="text-decoration:none;"
                                                        class="button is-text is-small"
                                                        @click="convertCompany(index, props.row)"
                                                        title="Übertragen"
                                                        v-if="editable">
                                                    <b-icon icon="search" type="is-warning"
                                                            pack="fas"></b-icon>
                                                </button>
                                                <button style="text-decoration:none;"
                                                        class="button is-text is-small"
                                                        @click="deleteCompany(index, props.row.data)"
                                                        title="Löschen"
                                                        v-if="editable">
                                                    <b-icon icon="minus-circle" type="is-danger"
                                                            pack="fas"></b-icon>
                                                </button>
                                            </div>
                                            <b-field
                                                    v-for="input in $root.event.guests.companiesFields"
                                                    :class="'emt-input-'+input.type">
                                                <template slot="label">
                                                    {{input.label}}<span style="font-weight: 400"
                                                                         v-if="input.required"> (Pflichtfeld)</span>
                                                </template>
                                                <b-input
                                                        v-if="input.type == 'email'"
                                                        v-model="compi['info_'+input.name]"
                                                        type="email" :disabled="!editable"
                                                        icon="envelope"
                                                        icon-pack="fad"></b-input>
                                                <b-select
                                                        v-else-if="input.type == 'enum'"
                                                        v-model="compi['info_'+input.name]"
                                                        :disabled="!editable"
                                                        placeholder="Bitte auswählen">
                                                    <option
                                                            v-for="option in input.options.split(',')"
                                                            :value="option">
                                                        {{ option }}
                                                    </option>
                                                </b-select>
                                                <Datepicker
                                                        v-else-if="input.type == 'date'"
                                                        v-model="compi['info_'+input.name]"
                                                        :disabled="!editable"
                                                        icon="calendar-day"
                                                        pack="fad"></Datepicker>
                                                <Timepicker
                                                        v-else-if="input.type == 'time'"
                                                        v-model="compi['info_'+input.name]"
                                                        :disabled="!editable"
                                                        icon="clock"
                                                        pack="fad"></Timepicker>
                                                <b-numberinput
                                                        v-else-if="input.type == 'int'"
                                                        v-model="compi['info_'+input.name]"
                                                        min="0"
                                                        icon-pack="fal"
                                                        :disabled="!editable"></b-numberinput>
                                                <b-input
                                                        v-else-if="input.type == 'multiline'"
                                                        v-model="compi['info_'+input.name]"
                                                        :disabled="!editable"
                                                        type="textarea"></b-input>

                                                <b-input
                                                        v-else
                                                        v-model="compi['info_'+input.name]"
                                                        :disabled="!editable"
                                                        icon-pack="fad"></b-input>

                                            </b-field>
                                        </div>

                                    </div>
                                </b-tab-item>
                                <b-tab-item label="Events">
                                    <div class="field buttons guest-view">
                                        <b-checkbox
                                                :class="checkWorkshopConflict(props.row, event.id) ? 'button is-danger has-text-white' : 'button'"
                                                v-for="event in $root.event.workshops"
                                                :indeterminate="event.mandatory"
                                                v-model="props.row.data.workshops['workshop_'+event.id+'_registered']"
                                                :disabled="(availableWorkshopSlots(event.id) <= 0 && !userIsInWorkshop(props.row, event.id)) || !editable || timeslotFull(props.row, event.id) || event.mandatory === true">
                                            {{ event.name }} <span v-if="event.quotaExists">({{availableWorkshopSlots(event.id)}} frei) </span>
                                            <b-dropdown hoverable position="is-top-right">
                                                <b-icon slot="trigger" size="is-small" icon="info-square"
                                                        pack="fal"></b-icon>
                                                <b-dropdown-item aria-role="listitem" disabled>{{ event.name
                                                    }}
                                                </b-dropdown-item>
                                                <b-dropdown-item aria-role="listitem" disabled>
                                                    <b-icon icon="calendar-alt" pack="fad"></b-icon>&nbsp;&nbsp;{{$moment(event.date,
                                                    'YYYY-MM-DD').format('dddd, D. MMM YY')}}
                                                </b-dropdown-item>
                                                <b-dropdown-item aria-role="listitem" disabled>
                                                    <b-icon icon="clock" pack="fad"></b-icon>&nbsp;&nbsp;{{event.begin}}
                                                    - {{event.end}}
                                                </b-dropdown-item>
                                                <b-dropdown-item v-if="event.quotaExists" aria-role="listitem"
                                                                 disabled>
                                                    <b-icon icon="users" pack="fad"></b-icon>&nbsp;&nbsp;maximal
                                                    {{event.quota}} Plätze
                                                </b-dropdown-item>
                                            </b-dropdown>
                                        </b-checkbox>
                                    </div>
                                </b-tab-item>
                                <b-tab-item label="Unterbringung">
                                    <div class="field buttons guest-view">
                                        <b-checkbox
                                                :class="checkAccommodationConflict(props.row, event.id) ? 'button is-danger has-text-white' : 'button'"
                                                v-for="event in $root.event.accommodations"
                                                v-model="props.row.data.accommodations['accommodation_'+event.id+'_registered']"
                                                :disabled="(availableAccommodationSlots(event.id) <= 0 && !userIsInAccommodation(props.row, event.id)) || !editable">
                                            {{ event.name }} <span v-if="event.quotaExists">({{availableAccommodationSlots(event.id)}} frei) </span>
                                            <b-dropdown hoverable position="is-top-right">
                                                <b-icon slot="trigger" size="is-small" icon="info-square"
                                                        pack="fal"></b-icon>
                                                <b-dropdown-item aria-role="listitem" disabled>{{ event.name
                                                    }}
                                                </b-dropdown-item>
                                                <b-dropdown-item aria-role="listitem" disabled>
                                                    {{event.description}}
                                                </b-dropdown-item>
                                                <b-dropdown-item v-if="event.quotaExists" aria-role="listitem"
                                                                 disabled>
                                                    <b-icon icon="users" pack="fad"></b-icon>&nbsp;&nbsp;maximal
                                                    {{event.quota}} Plätze
                                                </b-dropdown-item>
                                            </b-dropdown>
                                        </b-checkbox>
                                    </div>
                                </b-tab-item>
                                <b-tab-item label="Transfers">
                                    <div class="field buttons guest-view">
                                        <b-checkbox class="button" v-for="event in shownTransfers(props.row)"
                                                    v-model="props.row.data.transfers['transfer_'+event.id+'_registered']"
                                                    :disabled="!editable">
                                            {{ event.name }}&nbsp;
                                            <b-dropdown hoverable position="is-top-right">
                                                <b-icon slot="trigger" size="is-small" icon="info-square"
                                                        pack="fal"></b-icon>
                                                <b-dropdown-item aria-role="listitem" disabled>{{ event.name
                                                    }}
                                                </b-dropdown-item>
                                                <b-dropdown-item aria-role="listitem" disabled>
                                                    <b-icon icon="calendar-alt" pack="fad"></b-icon>&nbsp;&nbsp;{{$moment(event.date,
                                                    'YYYY-MM-DD').format('dddd, D. MMM YY')}}
                                                </b-dropdown-item>
                                                <b-dropdown-item aria-role="listitem" disabled>
                                                    <b-icon icon="clock" pack="fad"></b-icon>&nbsp;&nbsp;{{event.begin}}
                                                    - {{event.end}}
                                                </b-dropdown-item>
                                            </b-dropdown>
                                        </b-checkbox>
                                    </div>
                                </b-tab-item>
                            </b-tabs>
                        </div>
                    </div>
                </article>
            </template>
            <template slot="empty" v-if="$root.env.loading.users === false">
                <section class="section">
                    <div class="content has-text-grey has-text-centered">
                        <p>
                            <b-icon icon="frown" pack="fal" size="is-large">
                            </b-icon>
                        </p>
                        <p>Nothing here.</p>
                    </div>
                </section>
            </template>
        </b-table>

        <b-modal :active.sync="isCardModalActive" scroll="keep" :can-cancel="false">
            <div class="card is-modal">
                <header class="card-header">
                    <p class="card-header-title">
                        <b-icon icon="filter" pack="fas"></b-icon>&nbsp;&nbsp;neuer Filter
                    </p>
                </header>
                <div class="card-content">
                    <b-field label="Bedingung" horizontal class="field-grid">
                        <b-select v-model="editableFilter.name"
                                  :disabled="editableFilter.name">
                            <option
                                    aria-role="listitem"
                                    v-for="option in filterOptions.filters"
                                    :value="option.name"
                                    >
                                {{ option.label }}
                            </option>
                        </b-select>
                        <b-select v-model="editableFilter.operator" :disabled="editableFilter.operator" v-if="editableFilter.name" @input="updateEditableFilter()">
                            <option
                                    aria-role="listitem"
                                    v-for="option in getFilter(editableFilter.name).operators"
                                    :value="option.name"
                            >
                                {{ option.label }}
                            </option>
                        </b-select>
                        <b-select
                                v-model="editableFilter.entity"
                                v-if="editableFilter.name && editableFilter.operator && getOperator(editableFilter.name, editableFilter.operator).entities !== false">
                            <option
                                    aria-role="listitem"
                                    v-for="option in getFilter(editableFilter.name).entities($root.event)"
                                    :value="option.id">
                                {{ option.label }}
                            </option>
                        </b-select>
                            <b-input
                                    v-model="editableFilter.value"
                                    v-if="editableFilter.name && editableFilter.operator && getOperator(editableFilter.name, editableFilter.operator).value === 'string'">

                            </b-input>
                            <b-numberinput
                                    v-model="editableFilter.value"
                                    v-if="editableFilter.name && editableFilter.operator && getOperator(editableFilter.name, editableFilter.operator).value === 'number'">

                            </b-numberinput>

                    </b-field>

                    <b-field horizontal><!-- Label left empty for spacing -->
                        <p class="control">
                            <div class="buttons">
                                <button class="button is-primary" @click="addFilter()"
                                                             v-if="editableFilter.name && editableFilter.operator">
                                Filter hinzufügen
                                </button>
                                <button class="button is-warning" @click="editableFilter = {}">
                                    reset
                                </button>
                                <button class="button is-warning" @click="cancelFilter()">
                                    abbrechen
                                </button>
                            </div>
                        </p>
                    </b-field>
                </div>
            </div>
        </b-modal>

    </div>
</template>

<script>

    import Filters from './Helper/Filters'

    export default {
        name: 'Users',
        props: {},
        data() {
            return {
                updateTable: 1,
                search: '',
                isCardModalActive: false,
                editable: false,
                editableFilter: {},
                filters: [],
                filterMode: 'and',
                filterOptions: Filters,
                checkedRows: [],
                collapse: {
                    event: {},
                    accomodation: {},
                    transfer: {},
                    fields: {}
                },
                temp: {
                    filterSearch: '',
                    filterLoad: false,
                    saveTargetgroup: false,
                },
                fields: {},
            }
        },
        methods: {
            openNewPost(url, params) {
                let name = 'EtMwExportData'
                var form = document.createElement("form");
                form.setAttribute("method", "post");
                form.setAttribute("action", url);
                form.setAttribute("target", name);

                for (var i in params) {
                    if (params.hasOwnProperty(i)) {
                        var input = document.createElement('input');
                        input.type = 'hidden';
                        input.name = i;
                        input.value = params[i];
                        form.appendChild(input);
                    }
                }

                document.body.appendChild(form);

                //note I am using a post.htm page since I did not want to make double request to the page
                //it might have some Page_Load call which might screw things up.
                window.open("post.html", name);

                form.submit();

                document.body.removeChild(form);
            },
            exportFiltered(){
                let params = {
                    euser: this.$root.env.auth.credentials.username,
                    epassword: this.$root.env.auth.credentials.password
                }
                let url = this.$root.env.config.apiURL + 'export/' + this.$root.event.id
                params.ids = this.selectedIds
                this.openNewPost(url, params)
            },
            clearFilter() {
                this.search = ''
                this.search = ' '
                this.search = ''
                while (this.filters.length > 0) {
                    this.filters.pop();
                }
            },
            filterEntities() {
                if (!this.editableFilter.type) return []

                let ret = []
                switch (this.editableFilter.type) {
                    case 'wks':
                        this.$root.event.workshops.forEach(e => {
                            ret.push({entity: e.id, label: e.name})
                        })
                        break
                    case 'acm':
                        this.$root.event.accommodations.forEach(e => {
                            ret.push({entity: e.id, label: e.name})
                        })
                        break
                    case 'trf':
                        this.$root.event.transfers.forEach(e => {
                            ret.push({entity: e.id, label: e.name})
                        })
                        break
                    default:
                        break
                }
                return ret
            },
            addFilter() {
                this.filters.push(this.editableFilter)
                this.editableFilter = {}
                this.temp.filter = {}
                this.temp.search = ''
                this.temp.search = ' '
                this.temp.search = ''
                this.isCardModalActive = false
            },
            cancelFilter() {
                this.editableFilter = {}
                this.temp.filter = {}
                this.temp.search = ''
                this.temp.search = ' '
                this.temp.search = ''
                this.isCardModalActive = false
            },
            update(id = this.$route.params.id) {
                //this.$root.getUsers(id)
                return true
            },
            addCompany(row) {
                row.companies.push({})
            },
            convertCompany(index, user) {
                // if(!index || !user) return
                if (user.data.companies.length == 0) return
                const self = this
                this.$buefy.dialog.confirm({
                    title: `Gast Übernehmen`,
                    message: `Es werden Übereinstimmungen bei der Mail-Adresse gesucht. Bereits übermittelte Daten werden überschrieben.`,
                    cancelText: 'Abbrechen',
                    confirmText: 'Übernehmen',
                    type: 'is-success',
                    onConfirm: () => {
                        let field = self.$root.event.guests.companiesFields.find(e => e.type == 'email').name
                        let mail = user.data.companies[index]['info_' + field]
                        let target = self.$root.users.filter(u => u.field_1 == mail)
                        user.data.companies.splice(index, 1)
                        self.$root.saveUser(user.id, user.data)
                        target.forEach(t => {
                            t.data = Object.assign({}, user.data)
                            self.$root.saveUser(t.id, t.data)
                        })
                        return
                    }
                })
            },
            deleteCompany(index, row) {
                row.companies.splice(index, 1)
            },
            prepUser(user) {
                if (!user.data.workshops) {
                    user.data.workshops = {}
                }
                if (Array.isArray(user.data.workshops)) {
                    user.data.workshops = {}
                }
                if (!user.data.accommodations) {
                    user.data.accommodations = {}
                }
                if (Array.isArray(user.data.accommodations)) {
                    user.data.accommodations = {}
                }
                if (!user.data.transfers) {
                    user.data.transfers = {}
                }
                if (Array.isArray(user.data.transfers)) {
                    user.data.transfers = {}
                }
                if (!user.data.additionalInfo || user.data.additionalInfo.length == 0) {
                    user.data.additionalInfo = {}
                }
                if (!user.data.alteredFields || user.data.alteredFields.length == 0) {
                    user.data.alteredFields = {}
                }
                if (!user.data.companies) {
                    user.data.companies = []
                }
            },
            checkWorkshopConflict(user, id) {
                if (typeof user.data.conflict == 'object') {
                    if (user.data.conflict['workshop_' + id] == 'full') {
                        return true
                    }
                }
                return false
            },
            userIsInWorkshop(user, id) {
                if (this.$root.event.stats['workshop_' + id]) {
                    if (this.$root.event.stats['workshop_' + id].includes(user.id)) {
                        return true
                    }
                }
                return false
            },
            availableWorkshopSlots(id) {
                if (this.$root.event.stats['workshop_' + id] && this.$root.event.workshops.find(r => r.id == id).quotaExists) {
                    return this.$root.event.workshops.find(r => r.id == id).quota - this.$root.event.stats['workshop_' + id].length
                }
                return this.$root.event.workshops.find(r => r.id == id).quota
            },
            checkAccommodationConflict(user, id) {
                if (typeof user.data.conflict == 'object') {
                    if (user.data.conflict['accommodation_' + id] == 'full') {
                        return true
                    }
                }
                return false
            },
            userIsInAccommodation(user, id) {
                if (this.$root.event.stats['accommodation_' + id]) {
                    if (this.$root.event.stats['accommodation_' + id].includes(user.id)) {
                        return true
                    }
                }
                return false
            },
            availableAccommodationSlots(id) {
                if (this.$root.event.stats['accommodation_' + id] && this.$root.event.accommodations.find(r => r.id == id).quotaExists) {
                    return this.$root.event.accommodations.find(r => r.id == id).quota - this.$root.event.stats['accommodation_' + id].length
                }
                return this.$root.event.accommodations.find(r => r.id == id).quota
            },
            timeslotFull(user, id) {
                let ret = false
                let w = this.$root.event.workshops.find(r => r.id == id)
                if (!w.timeslotExists) return false
                this.$root.event.workshops.forEach(r => {
                    if (r.timeslotExists && r.timeslot == w.timeslot && user.data.workshops['workshop_' + r.id + '_registered'] == true && r.id != w.id) {
                        ret = true
                    }
                })
                return ret
            },
            toggle(row) {
                this.$refs.table.toggleDetails(row)
            },
            getFilter(name){
                return this.filterOptions.filters.find(f => f.name === name)
            },
            getOperator(filter, name){
                return this.getFilter(filter).operators.find(f => f.name === name)
            },
            updateEditableFilter(){
                const operator = this.getOperator(this.editableFilter.name, this.editableFilter.operator)
                if(typeof operator.value === 'string') this.editableFilter.value = operator.default
            },
            saveFilter(){
                this.$buefy.dialog.prompt({
                    message: `Bezeichnung des Filters`,
                    trapFocus: true,
                    onConfirm: (value) => {
                        let filter = {
                            id: this.$root.uuid(),
                            label: value,
                            filters: this.filters,
                            mode: this.filterMode
                        }
                        if(!Array.isArray(this.$root.event.filters)) this.$root.event.filters = []
                        if (this.search.length >= 3) {
                            filter.filters.push({
                                name: 'textSearch',
                                value: this.search
                            })
                        }
                        this.$root.event.filters.push(filter)
                        this.temp.filterLoad = false
                        this.$root.saveEvent(this.$root.saveEvent(this.$route.params.id))
                        this.$buefy.toast.open(`Folgender Filter wurde gespeichert: ${value}`)
                    }
                })
            },
            loadFilter(){
                if(typeof this.temp.filterToLoad !== 'object') return false

                let index = this.temp.filterToLoad.filters.findIndex(f => f.name === 'textSearch')
                console.log(index)
                if(index >= 0){
                    this.search = this.temp.filterToLoad.filters[index].value
                    this.temp.filterToLoad.filters.splice(index, 1)
                }
                this.filters = this.temp.filterToLoad.filters
                this.filterMode = this.temp.filterToLoad.mode
                this.temp.filterLoad = false
                this.$buefy.toast.open(`Folgender Filter wurde geladen: ${this.temp.filterToLoad.label}`)
            },
            saveTargetgroup(){
                this.$buefy.dialog.prompt({
                    message: `Bezeichnung der Zielgruppe`,
                    trapFocus: true,
                    inputAttrs: {
                        value: this.temp.targetgroupToSave.label
                    },
                    onConfirm: async (value) => {
                        let targetgroup = Object.assign({}, this.temp.targetgroupToSave)
                        targetgroup.label = value
                        targetgroup.ids= this.selectedIds
                        if(targetgroup.type === 'new') targetgroup.id = this.$root.uuid()
                        targetgroup.descr = `Zielgruppe für Event "${this.$root.event.name}" (ID: ${this.$root.event.id}),`
                        targetgroup.descr += ` berechnet am ${this.$moment().format('DD.MM.YYYY - HH:mm:ss')} -- id${targetgroup.id}`
                        targetgroup.updatedAt = this.$moment().format('YY-MM-DD HH:mm:ss')
                        if(!Array.isArray(this.$root.event.targetgroups)) this.$root.event.targetgroups = []
                        const callback = t => {
                            if(targetgroup.type === 'new'){
                                this.$root.event.targetgroups.push(t)
                                return true
                            }else{
                                Object.assign(this.$root.event.targetgroups.find(target => target.id === targetgroup.id), t)
                                return true
                            }
                        }
                        await this.$root.postAccount('targetgroup', targetgroup, false, callback)
                        await this.$root.saveEvent(this.$route.params.id)
                        this.$buefy.toast.open(`Folgendende Zielgruppe wurde gespeichert: ${value}`)
                        this.temp.saveTargetgroup = false
                    }
                })
            }
        },
        created() {
            // fetch the data when the view is created and the data is
            // already being observed
            this.update()
        },
        filters: {
            emphSearch: function (value, search) {
                if (!value) return ''
                if (search == '') return value
                if (search.length < 3) return value
                value = value.toString();
                const hashReg = new RegExp(search, "i");
                value = value.replace(hashReg, "<b>$&</b>");
                return value;
            }
        },
        computed: {
            filteredAccountFields(){
                return Array.isArray(this.$root.env.account.fields.filtered) ? this.$root.env.account.fields.filtered : []
            },
            selectedIds(){
                let ids = []
                if(this.checkedRows.length > 0){
                    this.checkedRows.forEach(u => ids.push(u.id))
                }else{
                    this.filtered.forEach(u => ids.push(u.id))
                }
                return ids
            },
            hideFilterMenu(){
                if(this.temp.saveTargetgroup === true)  return true
                if(this.temp.filterLoad === true)  return true
                return false
            },
            progress(){
              if(this.$root.users.length === 0) return undefined;

              return (100 * this.$root.users.length / this.$root.event.counter.recipients)
            },
            columns(){
                this.updateTable++
                if(this.$root.event.fields.table) return this.$root.env.account.fields.filtered.filter(e => this.$root.event.fields.table.includes(e.id))
                return []
            },
            filtersRendered(){
                let ret = []
                this.filters.forEach(f => {
                    let r = {
                        name: f.name,
                        operator: f.operator
                    }
                    r.filterLabel = this.getFilter(f.name).label
                    r.operatorLabel = this.getOperator(f.name,f.operator).label
                    r.icons = this.getOperator(f.name,f.operator).icons
                    r.fullLabel = r.filterLabel+': '+r.operatorLabel
                    if(this.getOperator(f.name,f.operator).entities !== false){
                        r.entity = this.getFilter(f.name).entity(this.$root.event, f.entity)
                        r.fullLabel += ' '+r.entity.label
                    }
                    if(typeof f.value !== 'undefined'){
                        r.fullLabel += ' '+f.value
                        r.value = +f.value
                    }
                    ret.push(r)
                })
                return ret
            },
            filtered() {
                let origin = [],
                    filtered = [],
                    patt = new RegExp(this.search, "i");

                // if(!Array.isArray(this.$root.users)) return []
                origin = this.$root.users

                if (this.filters.length > 0) {
                    origin = origin.filter(user => {
                        let matches = 0
                        this.filters.forEach(f => {
                            let result = this.getOperator(f.name,f.operator).filter(this.$root.event, user, f.entity, f.value)
                            if(result) matches++
                            return result
                        })
                        if(this.filterMode === 'and' && matches === this.filters.length) return true
                        if(this.filterMode === 'andOr' && matches > 0) return true
                        if(this.filterMode === 'or' && matches === 1) return true
                        return false
                    })
                }

                if (this.search == '') {
                    return origin
                }
                if (this.search.length < 3) {
                    return origin
                }
                origin.forEach(entry => {
                    if (patt.test(entry.field_1)) {
                        filtered.push(entry)
                        return
                    }
                    this.columns.forEach(c => {
                        if (patt.test(entry['field_'+c.id])) {
                            filtered.push(entry)
                            return
                        }
                    })
                })
                return filtered
            },
            shownTransfers() {
                return user => {
                    let filtered = []

                    this.$root.event.transfers.forEach(entry => {
                        let start = false,
                            destination = false,
                            end = false,
                            begin = false
                        switch (entry.type) {
                            case 'main':
                                filtered.push(entry)
                                break;
                            case 'accEvent':
                                this.$root.event.accommodations
                                    .filter(strt => strt.id == entry.start)
                                    .forEach(tre => {
                                        if (user.data.accommodations['accommodation_' + tre.id + '_registered']) {
                                            start = true
                                        }
                                    })
                                this.$root.event.workshops
                                    .filter(dst => dst.location == entry.destination)
                                    .forEach(tre => {
                                        if (user.data.workshops['workshop_' + tre.id + '_registered'] == true) {
                                            destination = true
                                        }
                                        if (this.$moment(entry.date + ' ' + entry.end).isSameOrBefore(tre.date + ' ' + tre.begin)) {
                                            end = true
                                        }
                                    })
                                if (start && destination && end) {
                                    filtered.push(entry)
                                }
                                break;
                            case 'eventEvent':
                                this.$root.event.workshops
                                    .filter(strt => strt.location == entry.start)
                                    .forEach(tre => {
                                        if (user.data.workshops['workshop_' + tre.id + '_registered']) {
                                            start = true
                                        }
                                        if (this.$moment(entry.date + ' ' + entry.begin).isSameOrAfter(tre.date + ' ' + tre.end)) {
                                            begin = true
                                        }
                                    })
                                this.$root.event.workshops
                                    .filter(dst => dst.location == entry.destination)
                                    .forEach(tre => {
                                        if (user.data.workshops['workshop_' + tre.id + '_registered'] == true) {
                                            destination = true
                                        }
                                        if (this.$moment(entry.date + ' ' + entry.end).isSameOrBefore(tre.date + ' ' + tre.begin)) {
                                            end = true
                                        }
                                    })
                                if (start && destination && begin && end) {
                                    filtered.push(entry)
                                }
                                break;
                            case 'eventAcc':
                                this.$root.event.workshops
                                    .filter(strt => strt.location == entry.start)
                                    .forEach(tre => {
                                        if (user.data.workshops['workshop_' + tre.id + '_registered']) {
                                            start = true
                                        }
                                        if (this.$moment(entry.date + ' ' + entry.begin).isSameOrAfter(tre.date + ' ' + tre.end)) {
                                            begin = true
                                        }
                                    })
                                this.$root.event.accommodations
                                    .filter(dst => dst.id == entry.destination)
                                    .forEach(tre => {
                                        if (user.data.accommodations['accommodation_' + tre.id + '_registered'] == true) {
                                            destination = true
                                        }
                                    })
                                if (start && destination && begin) {
                                    filtered.push(entry)
                                }
                                break;

                            default:
                                break;
                        }
                    })

                    this.$root.event.transfers.filter(strt => !filtered.includes(strt)).forEach(tre => {
                        if (user.data.transfers['transfer_' + tre.id + '_registered']) {
                            user.data.transfers['transfer_' + tre.id + '_registered'] = false
                        }
                    })

                    if (filtered.length > 0) {
                        return filtered
                    }
                    return false
                }
            }
        }

    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style>
    .user-sections section {
        margin-bottom: 10px;
    }

    .user-sections section:last-child {
        margin-bottom: 0px;
    }

    .guestBlocks {
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start;

    }

    .guestBlocks > div {
        width: 300px;
        position: relative;
        padding: 20px;
        margin: 3px;
        border-radius: 10px;
        border: 1px solid #c3c3c3;

    }

    .filterTags{
        justify-content: flex-end;
    }

    .filterTags .tag{
        margin: 2px;
    }

    .limitedDD .dropdown-content{
        height: 200px;
        overflow: auto;
    }

    .button.topRightCorner {
        position: absolute;
        top: -12px;
        right: -12px;
    }
</style>
